import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import onClickOutside from 'react-onclickoutside';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { spring, StaggeredMotion } from 'react-motion';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

const menuItems = [
  {
    path: '/main',
    text: 'nav.home',
    key: 'home',
    exact: true,
    icon: 'home',
  },
  {
    path: '/main/training',
    text: 'nav.train',
    key: 'training',
    icon: 'graduation-cap',
  },
  {
    path: '/main/retain',
    text: 'nav.retain',
    key: 'retain',
    icon: 'book-reader',
  },
  {
    path: '/main/promote',
    text: 'nav.promote',
    key: 'promote',
    icon: 'book-reader',
  },
  {
    path: '/main/sell',
    text: 'nav.sell',
    key: 'sell',
    icon: 'chart-line-up',
  },
  {
    path: '/logout',
    text: 'general.logOut',
    key: 'logout',
    icon: 'sign-out-alt',
  },
];

const startingPoints = [{ pos: 75 }, { pos: 75 }, { pos: 75 }, { pos: 75 }, { pos: 75 }, { pos: 75 }];

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientName: '',
    };
    // const container = document.getElementById('container');
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  UNSAFE_componentWillMount() {
    // container.classList.add('offsetContainer');
    this.getAppInfo();
  }

  handleClickOutside() {
    this.props.handleClickOutside();
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      const { clientName } = appInfo;
      this.setState({ clientName });
    }
  }

  render() {
    const { clientName: name } = this.state;
    return (
      <div className="sideMenu">
        <div
          className="sideMenu__Header"
          style={{
            backgroundImage: `url(https://front.travpromobile.com/${import.meta.env.VITE_APP_ID}/bg@2x.jpg)`,
          }}
        >
          <div onClick={this.handleClickOutside} className="sideMenu__Header-close">
            <FontAwesomeIcon icon={['fas', 'times']} />
          </div>
          <NavLink onClick={this.handleClickOutside} to="/main" className="sideMenu__Header-logo">
            <img
              src={`https://s3.amazonaws.com/developertool/${import.meta.env.VITE_APP_ID}/logo.png`}
              className="logo"
              alt={name}
            />
          </NavLink>
        </div>
        <div className="sideMenu__Nav">
          <StaggeredMotion
            defaultStyles={startingPoints}
            styles={(prevInterpolatedStyles) =>
              prevInterpolatedStyles.map((_, i) =>
                i === 0
                  ? { pos: spring(0, { stiffness: 320, damping: 28 }) }
                  : {
                      pos: spring(prevInterpolatedStyles[i - 1].pos, {
                        stiffness: 320,
                        damping: 28,
                      }),
                    },
              )
            }
          >
            {(styles) => (
              <ul>
                {menuItems.map((item, index) => {
                  const key = index;
                  return (
                    <li style={{ transform: `translateX(${styles[index].pos}%)` }} key={item.key}>
                      <NavLink
                        key={key}
                        onClick={this.handleClickOutside}
                        exact={item.exact === 'true'}
                        activeClassName="is-active"
                        to={item.path}
                      >
                        {item.icon && <FontAwesomeIcon icon={['fas', item.icon]} />}
                        {i18n.translate(item.text)}
                        {item.desc && <p className="sideMenu__description">{item.desc}</p>}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            )}
          </StaggeredMotion>
        </div>
      </div>
    );
  }
}

export default onClickOutside(SideMenu);

SideMenu.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  handleClickOutside: PropTypes.func,
};

SideMenu.defaultProps = {
  firstName: 'User',
  lastName: 'Name',
  email: 'username@email.com',
  handleClickOutside: () => {
    this.setState({
      menuToggle: false,
    });
  },
};
